import { Action } from '@ngrx/store';
import { CommandTypeModel } from '../../../_sdk/ems-devices/command-type.model';
import { ModelCollection } from '../../../_sdk/collection.model';

export const LOAD = 'COMMAND_LOAD';
export const LOAD_COMPLETE = 'COMMAND_LOAD_COMPLETE';

export const INSERT = 'COMMAND_INSERT';
export const INSERT_COMPLETE = 'COMMAND_INSERT_COMPLETE';

export const UPDATE = 'COMMAND_UPDATE';
export const UPDATE_COMPLETE = 'COMMAND_UPDATE_COMPLETE';

export const DELETE = 'COMMAND_DELETE';
export const DELETE_COMPLETE = 'COMMAND_DELETE_COMPLETE';

export const DISPOSE = 'COMMAND_DISPOSE';

export class Load implements Action {
    public readonly type = LOAD;
}

export class LoadComplete implements Action {
    public readonly type = LOAD_COMPLETE;

    constructor(public payload: ModelCollection<CommandTypeModel>) { }
}

export class Insert implements Action {
    public readonly type = INSERT;

    constructor(public payload: CommandTypeModel) { }
}

export class InsertComplete implements Action {
    public readonly type = INSERT_COMPLETE;

    constructor(public payload: CommandTypeModel) { }
}

export class Update implements Action {
    public readonly type = UPDATE;

    constructor(public payload: CommandTypeModel) { }
}

export class UpdateComplete implements Action {
    public readonly type = UPDATE_COMPLETE;

    constructor(public payload: CommandTypeModel) { }
}

export class Delete implements Action {
    public readonly type = DELETE;

    constructor(public payload: CommandTypeModel) { }
}

export class DeleteComplete implements Action {
    public readonly type = DELETE_COMPLETE;

    constructor(public payload: CommandTypeModel) { }
}

export class Dispose implements Action {
    public readonly type = DISPOSE;
}

export type Actions =
    Load | LoadComplete
    | Insert | InsertComplete
    | Update | UpdateComplete
    | Delete | DeleteComplete
    | Dispose;
